import { isPromiseLike } from '@spotify-internal/remote-config-common';
import React, { useState } from 'react';
import { useConfiguration } from '.';
export function connectRemoteConfig(mapping) {
    const useUnsafeMapping = () => {
        const config = useConfiguration();
        if (typeof mapping === 'function')
            return mapping(config);
        const entries = Object.entries(mapping);
        return objectFromEntries(entries.map(([key, ref]) => [key, config.getValue(ref)]));
    };
    const useSafeMapping = () => {
        const [, setSuspenseErr] = useState(null);
        try {
            return useUnsafeMapping();
        }
        catch (err) {
            if (!isPromiseLike(err))
                throw err;
            err.then(() => {
                setSuspenseErr(err);
            });
            return null;
        }
    };
    const hoc = createHoc(WrappedComp => props => {
        const mappedProps = useUnsafeMapping();
        const wrappedProps = Object.assign(Object.assign({}, props), mappedProps);
        return React.createElement(WrappedComp, Object.assign({}, wrappedProps));
    });
    const withFallback = (fallback) => {
        return createHoc(WrappedComp => props => {
            const mappedProps = useSafeMapping();
            const wrappedProps = Object.assign(Object.assign({}, props), mappedProps);
            return mappedProps ? React.createElement(WrappedComp, Object.assign({}, wrappedProps)) : React.createElement(React.Fragment, null, fallback);
        });
    };
    const withFallbackProps = (fallbackProps) => {
        return createHoc(WrappedComp => props => {
            const mappedProps = useSafeMapping() || fallbackProps;
            const wrappedProps = Object.assign(Object.assign({}, props), mappedProps);
            return React.createElement(WrappedComp, Object.assign({}, wrappedProps));
        });
    };
    return Object.assign(hoc, { withFallback, withFallbackProps });
}
function createHoc(factory) {
    return (WrappedComp) => {
        const EnhancedComp = factory(WrappedComp);
        EnhancedComp.displayName = `WithRemoteConfig(${WrappedComp.displayName || WrappedComp.name || 'Component'})`;
        return EnhancedComp;
    };
}
function objectFromEntries(entries) {
    const obj = {};
    for (const [key, value] of entries) {
        obj[key] = value;
    }
    return obj;
}
//# sourceMappingURL=connect.js.map